import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL,NT_STATUS,getSpinner,requestGet,requestPost} from './../constants';
import axios from 'axios';
import {stringToHex, validateInput} from "./../components/forms/validator";
import Waiter from './../assets/gif/blueCircle.gif';
let __form__={
    token:"",
    catName:""
    
};
const JComponent= () => {
    const navigate=useNavigate();
    const [form,setForm]=useState(__form__);
    const [rows,setRows]=useState([]);
    const [fetchOnReq,setFecthOnReq]=useState(false);
    const [assetsCategoryList,setAssetsCategoryList]=useState(null);
    useEffect(()=>{
        loadAssets();
    },[])
    const loadAssets=()=>{
        requestPost(API_CORE_SERVER+"/api/get_asset_category.php").then(data=>{
            setAssetsCategoryList(data);
        })
    }
    const __changeEvent=(e)=>{
        const {name,value}=e.target;
        setForm({...form,[name]:value});
        validateInput("#"+name);
            
    }
    const validateInput=(_qs)=>{
            let isValid=true;
            const input=document.querySelector(_qs);
            const name=input.getAttribute("id");
            input.classList.remove("is-invalid");
            const is_required=input.getAttribute("required")!=undefined?true:false;
            let inputErrLabel=document.querySelector("."+name+"-err");
            let errMessage="";
            if(input.value.trim().length==0 && is_required){
                isValid=false;input.classList.add("is-invalid");
                errMessage="can't be empty";
            }
            if(input.value.trim().length!=0){
                const classes=input.classList;
                if((classes.contains("input-text") && !/^[a-zA-Z]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-decimal") && !/^\d+(\.\d+)?$/.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-integer") && !/^[0-9]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-space") && !/^[a-zA-Z\s]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-number") && !/^[a-zA-Z0-9]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-number-space") && !/^[a-zA-Z0-9\s]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-number-space-dot") && !/^[a-zA-Z0-9\s\.]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-mixed") && !/^[a-zA-Z0-9\s\.\-_]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-yyyymmdd") && !/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(input.value))){isValid=false;input.classList.add("is-invalid");}
               errMessage=input.getAttribute("placeholder");
            }
            // create element
            if(isValid==false){
                if(inputErrLabel==undefined){
                    inputErrLabel=document.createElement("div");
                    inputErrLabel.innerHTML=errMessage;
                    inputErrLabel.classList.add("badge");
                    inputErrLabel.classList.add("bg-danger");
                    inputErrLabel.classList.add(name+"-err");
                    
                }
                document.querySelector("#"+name).parentElement.appendChild(inputErrLabel);
                
            }else{
                if(inputErrLabel!=undefined)
                    document.querySelector("."+name+"-err").remove();
            }
            return(isValid);
    }
    const validateForm=(_form_class)=>{
        let formData={};
        let isValid=true;
        const inputs=document.querySelector(_form_class).querySelectorAll(".input");
        for(let i=0;i<inputs.length;i++){
            const input=inputs[i];
            const name=input.getAttribute("id");
            formData[name]=input.value;
            isValid=isValid && validateInput("#"+name);
        }
        return({isValid:isValid,formData:formData});
    }
    const sendRecord=(_pageURL,_param,_button)=>{
            _param['token']=localStorage.getItem('_xoxex');
            document.querySelector(_button).innerHTML=getSpinner();
            return axios.post(_pageURL,_param)
            .then(response => {
                if(response.status==200){
                    const data=response.data;
                    if(data.status==1){
                        document.querySelector(".form").reset();
                        document.querySelector(".err").innerHTML="SUCCESSFULLY SAVED";
                        document.querySelector(_button).innerHTML="CREATE";
                        setTimeout(()=>{
                        document.querySelector(".err").innerHTML="";
                        },5000);
                        loadAssets();
                        return("success");
                    }
                    else if(data.status==-1){
                    document.querySelector(".err").innerHTML=data.msg==undefined?"Something went wrong":data.msg;
                    document.querySelector("#"+data.data).classList.add("is-invalid");
                    }
                    else document.querySelector(".err").innerHTML=data.msg==undefined?"Something went wrong":data.msg;
                    
                }
                document.querySelector(_button).innerHTML="CREATE";
                return("fail");
            })
            .catch(error => {
                document.querySelector(_button).innerHTML="CREATE";
                const _code=error.code;
                if(error.response!=undefined){
                    const _status=error.response.status;
                    if(NT_STATUS[_code]!=undefined){
                    document.querySelector(".err").innerHTML=NT_STATUS[_code].message;
                    }
                }
                else{
                    if(NT_STATUS[_code]!=undefined){
                        document.querySelector(".err").innerHTML=NT_STATUS[_code].message;
                    }	
                }
                return("error");
            });

        }

    const __submit=(e)=>{
        document.querySelector(".err").innerHTML="";
        const formData=validateForm(".form");
        if(formData.isValid==true){
            if(document.querySelector("#cmd_submit_implagency").innerText.trim()=="CREATE"){
                const form=validateForm(".form");
                console.log(form);
                sendRecord(API_CORE_SERVER+"/api/mastersettings/asset-type.do.php",form.formData,"#cmd_submit_implagency");
            }
        }
        else console.log("Invalid Form");
        
    }

    return(
        <>
        
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Asset Type/Category</h5>
		<div className='row'>
		<div className='col-md-8 p-4'>
            <div className='px-4 py-0'>
                <ul>
                {
                    assetsCategoryList!=null && assetsCategoryList.map((item,index)=>{
                        return(
                            <li className='fs85rem'>{item.catName}</li>
                        )
                    })
                }
                </ul>
            </div>
        </div>    
        <div className='col-md-4 p-4'>
        	<div className='px-4 py-0'>
                <div className="" >
                    <h5 className="mb-4">Create Asset Type</h5>
                    <form className="form">
                        <div className="row mb-4">
                            <div className="col-md-12">
                                <div className="form-floating">
                                    <input type="text" className="form-control input input-mixed" id="catName"  name="catName" placeholder="no special character" required onChange={e=>{__changeEvent(e) }} onBlur={e=>{__changeEvent(e) }}/>
                                    <label for="psNo">Enter Asset Type</label>
                                </div>
                            </div>
                        </div>
                        <div className="mt-2 text-center fs85rem err "></div>
                        <div className="mt-2">
                            <button type="button" className="btn btn-lg btn-primary w-100" id="cmd_submit_implagency" onClick={e=>__submit(e)}>
                                CREATE
                            </button>
                            <div className="err fs085 text-center text-danger mt-4"></div>
                        </div>    
                    </form>
                </div>



            </div>
        </div>
        </div>    
        
        </>
    )
}
export default JComponent;
